<template>
	<div class="Exchange">
		<vs-prompt
			@cancel="canclelHandler"
			@accept="applyWork"
			@close="$router.push('/exchange')"
			:active.sync="activePrompt2"
			:title="$t('exchange.order')+' №' + model.id"
			:acceptText="$t('exchange.accept')"
			:cancelText="$t('exchange.decline')"
			color="primary"
			class="exchange-order-view"
		>
			<table class="order__details mr-3">
				<tbody>
<!--				<tr>-->
<!--					<td class="exchange-order-view__col-title">-->
<!--						<div>{{$t('exchange.countStages')}}: <b>{{model.milestones_count}}</b></div>-->
<!--					</td>-->
<!--					<td class="pl-5 md:pl-5">{{$t('exchange.price')}}: <b>{{model.price_author}} €</b></td>-->
<!--				</tr>-->
				<tr>
					<td class="exchange-order-view__col-title"><b>{{$t('exchange.nameWork')}}:</b></td>
					<td class="pl-5 md:pl-5 break-words hyphens-auto">{{ model.name }}</td>
				</tr>
				<tr>
					<td class="exchange-order-view__col-title"><b>{{$t('exchange.subject')}}:</b></td>
					<td class="pl-5 md:pl-5">
						{{ $getDeep(model.subject, subjects) }}
					</td>
				</tr>
				<tr>
					<td class="exchange-order-view__col-title"><b>{{$t('exchange.langWork')}}:</b></td>
					<td class="pl-5 md:pl-5">
						{{ $getDeep(model.language, languages) }}
					</td>
				</tr>
				<tr>
					<td class="exchange-order-view__col-title"><b>{{$t('exchange.countPages')}}:</b></td>
					<td class="pl-5 md:pl-5">{{ model.pages_number }}</td>
				</tr>
				<tr>
					<td class="exchange-order-view__col-title"><b>{{$t('exchange.deadline')}}:</b></td>
					<td class="pl-5 md:pl-5">{{ formatDate(model.due_date) }}</td>
				</tr>
				<tr>
					<td class="flex"><b>{{ $t('stages') }}:</b></td>
					<td>
						<div
							v-for="(workType, index) in model.work_type"
							:key="index"
							class="pl-5"
						>
							{{ getWorkString(workType, index) }}
							<span class="tooltip" v-if="!workType.is_paid">
								<feather-icon
									svgClasses="h-4 w-4 text-primary"
									icon="InfoIcon"
								></feather-icon>
								<span class="tooltiptext">{{ $t("deadlineCalculatedApproximately") }}</span>
							</span>
						</div>
					</td>
				</tr>
				<tr>
					<td> <b>{{$t('exchange.price')}}:</b></td>
					<td class="pl-5 md:pl-5">{{model.price_author}} €</td>
				</tr>
				<tr v-if="model.files && model.files.length">
					<td class="exchange-order-view__col-title"><b>{{$t('exchange.attachFile')}}:</b></td>
					<td class="pl-5 md:pl-5">
						<template v-for="file in model.files">
							<a
								target="_blank"
								:href="file.url"
								class="break-words hyphens-auto"
							>
								{{ file.name }}
							</a>
							<br>
						</template>
					</td>
				</tr>
				<tr v-if="model.description">
					<td class="exchange-order-view__col-title"><b>{{$t('exchange.comment')}}:</b></td>
					<td class="pl-5 md:pl-5 break-words hyphens-auto ">
						<span v-html="model.description" />
					</td>
				</tr>

<!--				<tr>-->
<!--					<td class="exchange-order-view__col-title"><b>{{$t('exchange.typeWork')}}</b></td>-->
<!--					<td class="pl-5 md:pl-5">-->
<!--						{{ $getDeep(model.work_type, works) }}-->
<!--					</td>-->
<!--				</tr>-->
<!--				<tr>-->
<!--					<td class="exchange-order-view__col-title"><b>{{$t('exchange.levelQuality')}}</b></td>-->
<!--					<td class="pl-5 md:pl-5">-->
<!--						{{ $getDeep(model.quality_level, levels) }}</td>-->
<!--				</tr>-->
				</tbody>
			</table>

		</vs-prompt>
		<vs-card v-if="$store.state.auth.role === 'admin'">
			<h1>{{$t('exchange.filter')}}</h1>
			<div class="vx-row">
				<div class="vx-col lg:w-3/5 w-full">
					<div class="vx-row">
						<div class="vx-col md:w-2/5 w-full pt-3">
							<div class="search">
								<vs-input
									v-model="search"
									:placeholder="$t('exchange.searchToName')"
									class="w-full"
								/>
							</div>
						</div>
						<div class="vx-col md:w-1/5 sm:w-1/3 w-full pt-3 fs-1rem">
							<v-select
								v-model="level"
								:placeholder="$t('exchange.level')"
								:options="levels"
								:reduce="country => country.id"
								class="single-row-select filter-input"
								label="name"
							/>
						</div>
						<div class="vx-col md:w-1/5 sm:w-1/3 w-full pt-3 fs-1rem">
							<v-select
								v-model="subject"
								:placeholder="$t('exchange.area')"
								:options="subjects"
								:reduce="country => country.id"
								class="single-row-select filter-input"
								label="name"
							/>
						</div>
						<div class="vx-col md:w-1/5 sm:w-1/3 w-full pt-3 fs-1rem">
							<v-select
								v-model="work"
								:placeholder="$t('exchange.type')"
								:options="works"
								:reduce="country => country.id"
								class="single-row-select filter-input"
								label="name"
							/>
						</div>
					</div>
				</div>
				<div class="vx-col lg:w-2/5 w-full">
					<div class="vx-row">
						<div class="vx-col sm:w-1/3 w-full pt-3">
							<vx-input-group>
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="off"
										format="dd.MM.yyyy"
										:placeholder="$t('exchange.off')"
										name="date"
									></vs-datepicker>
								</div>
							</vx-input-group>
						</div>
						<div class="vx-col sm:w-1/3 w-full pt-3">
							<vx-input-group>
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="to"
										format="dd.MM.yyyy"
										:placeholder="$t('exchange.to')"
										name="date"
									></vs-datepicker>
								</div>
							</vx-input-group>
						</div>
						<div class="vx-col sm:w-1/3 w-full pt-3">
							<vs-custom-button
								color="dark"
								type="border"
								@click="clearFilter"
								class="w-full pl-1 pr-1"
							>{{ $t('exchange.reset') }}</vs-custom-button>
						</div>
					</div>
				</div>
			</div>
<!--			<div class="filter" >-->
<!--				-->
<!--				-->
<!--			</div>-->
		</vs-card>
		<vx-card class="my-8">
			<div class="tab-text">
				<vs-table max-items="10"  v-model="selected" pagination :data="orders">
					<template slot="thead">
						<vs-th
							v-for="fil in field"
							:sort-key="fil.field"
              :key="fil.field"
							:style="'width:' +fil.width"
							:class="{
								'justify-center': fil.align && fil.align === 'center',
								'text-center': fil.align && fil.align === 'center'
							}"
						>
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr
							v-for="(tr, indextr) in data"
							:key="indextr"
							:class="{
								invite: tr.marker === 'invite',
								priority: tr.marker === 'priority'
							}"
						>
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'id'">
									<a :href="`${pathToOrder}/${tr.id}`" @click="openOrderInfo(tr)">
										{{ tr.id }}
									</a>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'name'">
									<a :href="`${pathToOrder}/${tr.id}`" @click="openOrderInfo(tr)">
										{{ tr.name }}
									</a>
								</vs-td>

								<vs-td @click="alert('te')" :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'user'">
									<!--											<router-link :to="'client/' + deepFind(tr, 'client.id')">-->
									<router-link :to="'/client/'+tr.user.user_id">
										{{ tr.user.username }}
									</router-link>
								</vs-td>

								<vs-td @click="alert('te')" :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'author.username'">
									<router-link v-if="tr[fil.field]" :to="'client/' + deepFind(tr, 'author.id')">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>

								<vs-td @click="alert('te')" :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'status'">
									<template>
												<span v-if="tr.status === 5" style="color: #efbb40">
													{{ $t('pendingConsideration') }}
												</span>
										<span v-if="tr.status === 10" style="color: #4ba44d">
													{{ $t('paidOut') }}
												</span>
										<span v-if="tr.status === 0" style="color: red">
													{{ $t('rejected') }}
												</span>
									</template>
								</vs-td>

                <template v-else-if="fil.field === 'due_date'">
                  <vs-td :class="{'text-center': fil.align && fil.align === 'center'}">
										{{ tr.due_date }}
                  </vs-td>
                </template>

								<template v-else-if="fil.field === 'actions'">
									<vs-td  :class="{'text-center': fil.align && fil.align === 'center'}" >
										<div class="flex column">
											<vs-button
												@click="trs = tr;applyWorkHandler()"
												size="small"
												color="success"
												class="mb-1"
											>{{$t('exchange.accept')}}</vs-button>

											<vs-button
												v-if="tr.marker === 'invite'"
												@click="trs = tr;canclelHandler()"
												size="small"
												color="danger"
											>{{$t('exchange.decline')}}</vs-button>
										</div>
									</vs-td>
								</template>


								<vs-td @click="alert('te')" :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'chat_messages_count'">
									<span
										class="counter"
										:class="{ warn: tr.is_chat_unread }"
									>
										{{ tr.chat_messages_count }}
									</span>
								</vs-td>

								<vs-td
									v-else-if="fil.field === 'subject'"
									:class="{'text-center': fil.align && fil.align === 'center'}"
									@click="alert('te')"
								>{{ $getDeep(tr.subject, subjects) }}</vs-td>

								<vs-td
									v-else-if="fil.field === 'work_type'"
									:class="{'text-center': fil.align && fil.align === 'center'}"
									@click="alert('te')"
								>{{ $getDeep(tr.work_type, works) }}</vs-td>

								<vs-td
									v-else-if="fil.field === 'quality_level'"
									:class="{'text-center': fil.align && fil.align === 'center'}"
									@click="alert('te')"
								>{{ $getDeep(tr.quality_level, levels) }}</vs-td>

								<vs-td @click="alert('te')" :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'task'">
									<span class="task" v-if="tr[fil.field]">{{tr[fil.field].date_time | moment('DD.MM.YYYY')}}</span>
									<span class="task" @click="idOrder = tr.id;activePrompt = true" v-else>+</span>
								</vs-td>

								<vs-td
									v-else-if="(tr[fil.field] || tr[fil.field] === 0) && fil.field !== 'id'"
									:class="{'text-center': fil.align && fil.align === 'center'}"
									@click="alert('te')"
								>{{ tr[fil.field] }}</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
	</div>
</template>

<script>
import notifier from "@/mixins/notifier";
import moment from 'moment'
import Datepicker from "vuejs-datepicker";
import vSelect from 'vue-select'

export default {
	name: "Exchange",
	mixins: [notifier],
	components: {
		Datepicker,
		'v-select': vSelect,
	},
	data() {
		return {
			languages: [],
			selected: '',
			user: '',
			clients: [],
			incomes: 0,
			idOrder: 0,
			date: "",
			off: "",
			indexTab: 0,
			to: "",
			about: "",
			amount: "",
			search: "",
			activePrompt: false,
			activePrompt2: false,
			popupActiv: false,
			task: {},
			orders: [],
			subjects: [],
			works: [],
			levels: [],
			tasks: [],
			field: [],

			model:{},

			level: '',
			work: '',
			subject: '',
			trs: '',
		};
	},
	watch:{
		off(){
			this.filter();
		},
		search(){
			this.filter();
		},
		level(){
			this.filter();
		},
		work(){
			this.filter();
		},
		subject(){
			this.filter();
		},
		to(){
			this.filter();
		},
	},
	computed: {
		pathToOrder() {
			const role = this.$store.state.auth.role;
			if(role === "admin") {
				return `/ticket`
			}

			return "#";
		},
	},
	methods: {
		async openPopupByUrl() {
      let id = this.$route.hash
			if (id.length > 0) {
				const order = this.orders.find(el => el.id == id.split('#/').join(''))
			  await this.openOrderInfo(order)
			}
		},
		formatDate(date) {
			if(!date) return '';

			return date
				.split('-')
				.reverse()
				.join('.');
		},
		getWorkString(workType, index) {
			const number =  `${ index + 1 }.`;
			const type = `${ this.$getDeep(workType.work_type_id, this.works) }`;
			const start = `${number} ${type}`;
			const pages = `${ this.$tc('pages', workType.pages) }`;
			const dueDate = this.formatDate(workType.due_date);

			return [start, pages, dueDate].join(', ');
		},
		async openOrderInfo(order) {
			this.trs = order;
			await this.getWork(order);
		},
		async cancelWork(){
			try {
				let res = (await this.$http.post('/author/work/cancel/'+this.trs.id)).data.data;
				this.activePrompt2 = false;
				this.$vs.notify({
					title: this.$t('exchange.inviteDecline'),
					text: this.$t('exchange.inviteDeclineText'),
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
				this.getTickets();
			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async applyWork(){
			try {
				let res = (await this.$http.post('/author/work/accept/'+this.trs.id)).data.data;
				if(this.trs.marker === "invite"){
					this.$vs.notify({
						title: this.$t('exchange.inviteAccept'),
						text: this.$t('exchange.inviteAcceptText'),
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'warning'
					})
				}else {
					this.$vs.notify({
						title: this.$t('exchange.requestSend'),
						text: this.$t('exchange.requestSendText'),
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'warning'
					})
				}
				this.getTickets();
			}catch (e) {
				this.notifyError(e.message);
			}
		},
		applyWorkHandler(){
			this.$vs.dialog({
				title: this.$t('exchange.confirmAction'),
				text: this.$t('exchange.confirmActionText'),
				acceptText: this.$t('exchange.confirmPopup'),
				accept:this.applyWork,
				color: "primary"
			});
		},
		canclelHandler(){
			if(this.trs.marker === "invite") {
				if(this.trs.marker){
					this.$vs.dialog({
						title: this.$t('exchange.confirmAction'),
						text: this.$t('exchange.confirmActionTextFalse'),
						acceptText: this.$t('exchange.confirmPopup'),
						accept:this.cancelWork,
						color: "primary"
					})
				}
			}
		},
		async getWork(object){
			try {
				this.model = (await this.$http.get('/author/work/view/'+object.id)).data.data;

				const order = this.orders.find(item => item.id === this.model.id);
				if(order) {
					this.$set(this.model, "milestones_count", order.milestones_count);
					this.activePrompt2 = true;
				}
			} catch (e) {
				console.log(e)
			}
		},
		clearFilter(){
			this.search = '';
			this.level = '';
			this.work = '';
			this.subject = '';
			this.to = '';
			this.off = '';
		},
		filter(){
			let options = '?';
			if(this.off) options += 'filter[date_from]='+moment(this.off).format('YYYY-MM-DD')+'&'
			if(this.to) options += 'filter[date_to]='+moment(this.to).format('YYYY-MM-DD')+'&'
			if(this.search) options += 'filter[name]='+this.search+'&'
			if(this.subject) options += 'filter[subject]='+this.subject+'&'
			if(this.work) options += 'filter[work_type]='+this.work+'&'
			if(this.level) options += 'filter[quality_level]='+this.level+'&'
			this.getTickets(options);
		},
		async removePayout(){
			try {
				await this.$http.post(
					"/admin/payout/cancel/" + this.model.id,
					{status_message: this.about}
				);
				this.notifySuccess(this.$t('exchange.successText'));
				this.popupActiv = false;
				this.getTickets();

			} catch (e) {
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					});

				}else{
					this.notifyError(e.message);
				}
			}
		},
		async payout(id){
			try {
				await this.$http.post(
					"/admin/payout/confirm/" + id
				);

				this.notifySuccess(this.$t('completedSuccessfully'));
				this.popupActiv = false;
				this.getTickets();

			} catch (e) {
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					});

				}else{
					this.notifyError(e.message);
				}
			}
		},
		async completeTask(id) {
			try {
				await this.$http.post(
					"/" + this.$store.state.auth.role + "/task/complete/" + id
				);

				this.notifySuccess(this.$t('exchange.successText'));
				this.popupActiv = false;

			} catch (e) {
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					});

				}else{
					this.notifyError(e.message);
				}
			}
		},
		async closeTask(id) {
			try {
				await this.$http.post(
					"/" + this.$store.state.auth.role + "/task/delete/" + id
				);
				this.notifySuccess(this.$t('exchange.successText'));
				this.popupActiv = false;
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async createTask(id) {
			try {
				let formData = {
					amount: this.amount,

				};
				await this.$http.post(
					"/" + this.$store.state.auth.role + "/payout/create/",
					formData
				);
				this.notifySuccess(this.$t('exchange.acceptText'));
				this.about = "";
				this.date = "";
				this.popupActiv = false;
				this.getTickets();

			} catch (e) {
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					});

				} else{
					this.notifyError(e.message);
				}
			}
		},
		openTask(model) {
			if (!model) {
				this.activePrompt = true;
			} else {
				this.task = model;
				this.popupActiv = true;
			}
		},
		findTask(id) {
			let res = this.tasks.filter(
				(task) => (task.order && task.order.id) === id
			)[0];
			return !!res ? res : null;
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getTickets(options) {
			try {
				let layout = this.$store.state.layout.layout.toLowerCase();
				let url = options && options.length > 2
					? "/" + layout + "/work" + options
					: "/" + layout + "/work";

				this.orders = (await this.$http.get(url)).data.data;
			} catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	async created() {
		if (this.$store.state.auth.role === "author") {
			this.field = [
				{
					field: "id",
					title: '№',
					width: '9%'

				},
				{
					field: "name",
					title: this.$t('exchange.name'),
					width: '12%'

				},
				{
					field: "subject",
					title: this.$t('exchange.area'),
					width: '12%'

				},
				{
					field: "work_type",
					title: this.$t('exchange.type'),
					width: '12%'
				},
				{
					field: "pages_number",
					title: this.$t('exchange.page'),
					width: '12%'
				},
				{
					field: "milestones_count",
					title: this.$t('exchange.stage'),
					width: '12%'
				},
				{
					field: "price_author",
					title: `${this.$t('exchange.price')}, €`,
					width: '12%'
				},
				{
					field: "due_date",
					title: this.$t('exchange.deadline'),
					width: '12%'
				},
				{
					field: "actions",
					title: "",
					align: 'center',
					width: '9%'
				},
			];
		}
		if (this.$store.state.auth.role === "admin") {
			this.field = [
				{
					field: "name",
					title: this.$t('exchange.name'),
					width: '9%'

				},
				{
					field: "quality_level",
					title: this.$t('exchange.level'),
					width: '9%'

				},
				{
					field: "subject",
					title: this.$t('exchange.area'),
					width: '9%'

				},
				{
					field: "work_type",
					title: this.$t('exchange.type'),
					width: '9%'
				},
				{
					field: "pages_number",
					title: this.$t('exchange.page'),
					width: '9%'
				},
				{
					field: "milestones_count",
					title: this.$t('exchange.stage'),
					width: '9%'
				},
				{
					field: "price_junior_middle",
					title: `${this.$t('exchange.price_junior_middle')}, €`,
					width: '9%'
				},
				{
					field: "price_senior",
					title: `${this.$t('exchange.price_senior')}, €`,
					width: '9%'
				},
				{
					field: "due_date",
					title: this.$t('exchange.deadline'),
					width: '9%'
				},

			];
		}
	},
	async mounted() {
		this.levels = (await this.$http.get("/settings/get-quality-levels")).data.data;
		this.languages = (await this.$http.get("/settings/get-languages")).data.data;
		this.works = (await this.$http.get("/settings/get-work-types")).data.data;
		this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;
		await this.getTickets();
		this.openPopupByUrl()
	},
};
</script>

<style lang="scss">
@import "../assets/scss/vuexy/variables.scss";
@import "../assets/scss/vuexy/functions.scss";

.exchange-order-view {
	.vs-dialog {
		width: 100%;
		max-width: 800px;
		max-height: calc(100% - 20px);
		display: flex;
		flex-direction: column;

		&-text {
			overflow: auto;
			max-height: 100%;
		}
	}

	&__col-title {
		display: flex;
		width: 220px;

		@media screen and (max-width: 768px) {
			width: 130px;
		}
	}

	.order__details {
		border-spacing: 0 5px;
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}

.Exchange {
	.buttons {
		justify-content: flex-end;
	}
	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}
	.inputInTable {
		border: 0;
		resize: none;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
	th.justify-center div{
		justify-content: center;
	}
	.con-vs-tabs{
		overflow: visible;
	}
	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}
	tr.invite{
		background-color: rgba(251, 227, 197, 0.75);
	}
	tr.priority{
		background-color: #D9EDCC;
	}
	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}
	.con-vs-tabs .con-slot-tabs{
		overflow: visible;
	}
	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}
	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		.date {
			display: flex;
			align-items: center;
		}
		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}
		.vx-input-group {
			margin-right: 20px;
		}
		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}
		.search .vs-con-input-label {
			width: 270px;
		}
	}
}

.fs-1rem {
	font-size: 1rem;
}

/* Tooltip container */
.tooltip {
	position: relative;
	display: inline-block;
	.tooltiptext {
		visibility: hidden;
		width: 240px;
		background-color: black;
		color: #fff;
		text-align: center;
		padding: 8px 4px;
		border-radius: 6px;
		font-size: 12px;
		bottom: 25px;
		right: -120px;
		/* Position the tooltip text - see examples below! */
		position: absolute;
		z-index: 100;
	}
	&:hover .tooltiptext {
		visibility: visible;
	}
}
</style>
